import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldText, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import styles from './headerRow.module.scss';
export const KEY_FIELD = 'key';
export const VALUE_FIELD = 'value';
export function HeaderRow({ field, index, onRemove }) {
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Field, { className: styles.field, component: FieldText, label: "Key", name: `${field}.${KEY_FIELD}`, placeholder: "Key", type: "option" }), _jsx(Field, { className: styles.field, component: FieldText, label: "Value", name: `${field}.${VALUE_FIELD}`, placeholder: "Value", type: "option" }), _jsx(IconButton, { className: styles.trash, icon: "trash", onClick: () => onRemove(index), variant: "tertiary" })] })));
}
